import { Label } from "@/components/ui/label";
import { InputDecimal } from "@/components/ui/input-decimal";

import Secao from "./Secao";

/** Minimo e maximo lado a lado, na unidade do ESTOQUE (kg com 3 casas; unidade
 *  e caixa sao numeros inteiros — nao se compra meia unidade). */
export default function SecaoEstoque({ numero = 4, unidadeEstoque, stockMin, setStockMin, stockMax, setStockMax, idPrefix = "" }) {
  // Regra do dono: minimo nunca igual ou maior que o maximo (so quando ha maximo)
  const mn = Number(stockMin) || 0, mx = Number(stockMax) || 0;
  const erro = mx > 0 && mn >= mx ? "O mínimo precisa ser menor que o máximo." : "";
  const kg = unidadeEstoque === "kg";
  const dec = kg ? 3 : 0;
  const suf = kg ? "kg" : "un";
  return (
    <Secao numero={numero} titulo="Estoque mínimo e máximo" ajuda={`Avisa quando o saldo ficar abaixo do mínimo. Em ${kg ? "kg" : "unidades inteiras"}.`} testId="secao-estoque">
      <div className="grid grid-cols-2 gap-3">
        <div>
          <Label htmlFor={`${idPrefix}stockMin`} className="text-xs">Mínimo</Label>
          <InputDecimal id={`${idPrefix}stockMin`} decimals={dec} sufixo={suf} value={stockMin} onChange={setStockMin} className="mt-1 h-10" />
        </div>
        <div>
          <Label htmlFor={`${idPrefix}stockMax`} className="text-xs">Máximo</Label>
          <InputDecimal id={`${idPrefix}stockMax`} decimals={dec} sufixo={suf} value={stockMax} onChange={setStockMax} className="mt-1 h-10" />
        </div>
      </div>
      {erro && <p className="text-xs text-destructive" data-e2e="erro-min-max">{erro}</p>}
    </Secao>
  );
}
